// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8) return "css/core.8.f3c3dde9e526213c4069.main.css";
	if (chunkId === 179) return "css/core.main.84b2b582537194d00749.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + {"172":"bot","405":"cfd","654":"trader"}[chunkId] + "." + {"172":"96c73fec66980ddf75a2","405":"cfb87cbb7a7986ac66aa","654":"b98f84b0d1a2182667c0"}[chunkId] + ".css";
};